// Dummy marketplace catalogue — swap the `logo` field for a real SVG/icon
// (e.g. from react-icons or each brand's official media kit) whenever
// you're ready. `color` is only used for the placeholder initial-badge.
export const marketplaces = [
  { key: "ebay", name: "eBay", color: "#E53238" },
  { key: "etsy", name: "Etsy", color: "#F1641E" },
  { key: "amazon", name: "Amazon", color: "#FF9900" },
  { key: "chrono24", name: "Chrono24", color: "#0071BC" },
  { key: "watchbox", name: "WatchBox", color: "#1B1F3B" },
];

// Deterministic dummy "is this product listed on X" data, so the same
// product always shows the same badges instead of flickering on every
// render. Once the backend sends `item.market_places` (an array of
// marketplace keys, e.g. ["ebay", "amazon"]), that real data is used
// automatically and this fallback is skipped.
function hashSeed(str) {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = (hash * 31 + str.charCodeAt(i)) >>> 0;
  }
  return hash;
}

export function getActiveMarketplaceKeys(item) {
  if (Array.isArray(item?.market_places)) {
    return item.market_places;
  }

  const seed = hashSeed(String(item?.product_code || item?.id || "wp"));
  return marketplaces
    .filter((_, index) => ((seed >> index) & 1) === 1)
    .map((mp) => mp.key);
}